import React from "react";

const CircleIcon = () => {
  return (
    <svg
      width="67"
      height="67"
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="33.4189"
        cy="33.5068"
        r="30.3936"
        stroke="#264D51"
        strokeWidth="5"
      />
    </svg>
  );
};

export default CircleIcon;
